import ACTIONS from '../storeActions';

const actions = {
  [ACTIONS.SIGNAL_R__SET_HUB_TOKEN]: (context, payload) => context.commit(ACTIONS.SIGNAL_R__SET_HUB_TOKEN, payload),
  [ACTIONS.SIGNAL_R__SET_RUN_STATE]: (context, payload) => context.commit(ACTIONS.SIGNAL_R__SET_RUN_STATE, payload),
  [ACTIONS.SIGNAL_R__HANDLE_CONNECT_EVENT]: (context, payload) => context.commit(ACTIONS.SIGNAL_R__HANDLE_CONNECT_EVENT, payload),
  [ACTIONS.SIGNAL_R__HANDLE_EXERCISE_CHANGE]: (context, payload) => context.commit(ACTIONS.SIGNAL_R__HANDLE_EXERCISE_CHANGE, payload),
  [ACTIONS.SIGNAL_R__HANDLE_DOCUMENT_CHANGE]: (context, payload) => context.commit(ACTIONS.SIGNAL_R__HANDLE_DOCUMENT_CHANGE, payload),
  [ACTIONS.SIGNAL_R__HANDLE_CHANGE_EVENT]: (context, payload) => context.commit(ACTIONS.SIGNAL_R__HANDLE_CHANGE_EVENT, payload),
  [ACTIONS.SIGNAL_R__HANDLE_CLIENT_PARTICIPANT_NETWORK_EVENT]: (context, payload) => context.commit(ACTIONS.SIGNAL_R__HANDLE_CLIENT_PARTICIPANT_NETWORK_EVENT, payload),
  [ACTIONS.SIGNAL_R__HANDLE_CLIENT_OBSERVER_NETWORK_EVENT]: (context, payload) => context.commit(ACTIONS.SIGNAL_R__HANDLE_CLIENT_OBSERVER_NETWORK_EVENT, payload)
}

export default actions;
